import {
	AUTH_MODAL_SHOW,
	AUTH_MODAL_HIDE,
	AUTH_CHECK_USER,
	AUTH_FLUSH_USER,
	AUTH_USER_DETAILS,
} from '../types';

import { firestore } from '../../firebase';

export const showAuth = () => {
	return {
		type: AUTH_MODAL_SHOW,
	};
};

export const hideAuth = () => {
	return {
		type: AUTH_MODAL_HIDE,
	};
};

export const checkUser = (user) => {
	return (dispatch) => {
		dispatch({
			type: AUTH_CHECK_USER,
			payload: user,
		});
	};
};

export const flushUser = () => {
	return {
		type: AUTH_FLUSH_USER,
	};
};

export const getDetails = (uid) => {
	return (dispatch) => {
		firestore
			.collection('users')
			.where('uid', '==', uid)
			.get()
			.then((snapshot) => {
				snapshot.forEach((doc) => {
					const details = doc.data();
					details.doc = doc.id;
					dispatch({
						type: AUTH_USER_DETAILS,
						payload: details,
					});
				});
			});
	};
};
